<template>
  <div class="lg:px-20 md:px-12 px-5 lg:py-8 md:py-6 py-4">
    <div class="text-center sm-wfull mx-auto lg:flex md:flex gap-8 items-center">
      <div class="rounded-xl lg:w-1/2 md:w-1/2 w-full">
        <img
          class="lg:h-72 h-64 w-full rounded-xl mx-auto object-cover"
          :src="`${$imageURL}/${getAllCategory.result[0].image}`"
          alt="img"
        />
        <!-- src="https://nimbuscluster.blob.core.windows.net/server01/default/images/default2.jpg" -->
      </div>
      <div class="lg:w-1/2 md:w-1/2 w-full">
        <p
          class="fsize40 md-fsize28 sm-fsize18 clr-black font-semibold pb-2"
        >
          <!-- Journey Of Compassion -->

          {{ getAllCategory.result[0].name }}
        </p>
        <p class="fsize20 sm-fsize14">
          <!-- Lorem ipsum dolor sit amet consectetur, adipisicing elit. Assumenda
          provident dignissimos voluptatum optio vitae alias quae debitis libero
          tempore -->
          {{ getAllCategory.result[0].description }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState("playlist", { getAllCategory: "getAllCategory" }),
  },
  async mounted() {
    try {
      // let data = await this.$store.dispatch("playlist/getall_category", {
      //   cid: this.$route.query.cid,
      // });
    } catch (error) {}
  },
};
</script>
